import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Explore from './pages/Explore';
import Profile from './pages/Profile';
import Notation from './pages/Notation';
import Playlists from './pages/Playlists';
import Stats from './pages/Stats';
import './App.css';

function App() {
  const location = useLocation();
  return (
    <div>
      <Navbar />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/notation" element={<Notation />} />
          <Route path="/playlists" element={<Playlists />} />
          <Route path="/stats" element={<Stats />} />
        </Routes>
      </AnimatePresence>
    </div>
  );
}

export default App;
